<template>
    <el-dialog
        v-loading.fullscreen.lock="loading"
        :visible.sync="abnormalVisible"
        :show-close="false"
        center
        width="420px"
        :before-close="handleClose">
        <div class="abnormal">
            <div class="abnormal_title">提交异常</div>
            <div class="abnormal_line"></div>
            <el-input type="textarea" v-model="value" size="small" resize="none" rows="5" placeholder="请描述异常情况"></el-input>
            <div class="abnormal_line"></div>
            <div class="abnormal_img">
                <div class="abnormal_img_item" v-if="imgList.length < 3">
                    <uploadImage :img="img" @imgUpload="imgUpload"></uploadImage>
                </div>
                <div class="abnormal_img_item"  @mouseover="selectIconIndex = index" @mouseleave="selectIconIndex = -1" v-for="(item,index) in imgList" :key="index">
                    <img :src="$imgUrl + item" alt="">

                    <img v-if="index != selectIconIndex" class="abnormal_img_item_icon1" src="../../../assets/img_done.png" alt="">
                    <img v-else class="abnormal_img_item_icon1" @click="deleteImg(index)" src="../../../assets/img_delete.png" alt="">
                </div>
                
            </div>
            <div class="abnormal_action">
                <el-button type="primary" @click="submit">确认提交</el-button>
            </div>
        </div>
        

    </el-dialog>
   
</template>

<script>
import uploadImage from '../../../components/uplaodImage'
export default {
    props:["abnormalVisible","item"],
   data (){
       return {
           value:'',
           img:require('../../../assets/upload.png'),
           imgList:[],
           selectIconIndex:'',
           loading:false
       }
   },
   components: {
       uploadImage
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       deleteImg(index){
           this.imgList.splice(index,1);
       },
       imgUpload(data){
           this.imgList.push(data.image_path);
       },
       submit(){
           this.loading = true;
           this.$post('OrderExceptional',{id:this.item.uuid,content:this.value,imageurl:this.imgList})
            .then(data => {
                this.loading = false;
                this.$message.success('提交异常成功！');
                this.$emit("abnormalCallback");
                this.$emit("update:abnormalVisible",false)
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });
       },
       handleClose(){
            this.$emit("update:abnormalVisible",false)   
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.abnormal{
    // padding: 0 35px;
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        text-align: center;
        margin-bottom:20px;
    }
    &_line{
        border-top:1px solid #E5E5E5;
        height: 1px;
        width:100%;
        margin:16px 0 16px 0; 
    }
    &_img{
        display: flex;
        &_item{
            
            margin-right:10px;
            position: relative;
            cursor: pointer;
            img{
                width:95px;
                height: 95px;
            }
            img.abnormal_img_item_icon1{
                width:24px;
                height: 24px;
                position: absolute;
                right: 0;
                top:0;
                cursor: pointer;
            }
        }
    }
    &_action{
        text-align: center;
        margin-top:30px;
        /deep/ .el-button{
            font-size: 16px;
            font-weight: normal;
            padding: 11px 19px;
        }
    }
    /deep/ .el-textarea__inner{
        background: #F9F9F9;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/components/abnormal.vue